import { takeLatest, put, call } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import * as numberVerifyActions from "../actions/index.action";
import * as numberVerifyTypes from "../types/index.types";
import { dispatchSnackbarError } from "../../../../utils/toaster";

const endpoints = {
    NUMBER_VERIFY: "/api/number-filter",
};

function* verifyNumberType(action) {
    try {
        const res = yield call(api.post, endpoints.NUMBER_VERIFY, action.payload);
        if (res.status === 200) {
            yield put(numberVerifyActions.verifyNumberSuccess(res.data));
        } else {
            dispatchSnackbarError(res.data.message);
            yield put(numberVerifyActions.verifyNumberFailure(res.data));
        }
        if (action.cb) action.cb(res.data);
    } catch (e) {
        yield put(numberVerifyActions.verifyNumberFailure(e));
    }
}

export default function* verifyNumberSaga() {
    yield takeLatest(numberVerifyTypes.verifyNumberType.REQUEST, verifyNumberType)
}
